// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","604":"company"}[chunkId] || chunkId) + "." + {"594":"d860cae6","604":"13c5cab0","624":"b391f112"}[chunkId] + ".js";
};